import { render, staticRenderFns } from "./toronto-medical-university.vue?vue&type=template&id=a3b66282&"
import script from "./toronto-medical-university.vue?vue&type=script&lang=js&"
export * from "./toronto-medical-university.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports